export default "__VITE_ASSET__BnlWlgdl__"